const APPLICATION_MENU = [
  // {
  //     id: "dashboard",
  //     icon: "icon-shield",
  //     text: "Menu.Dashboard",
  //     subMenuItems: [
  //         { text: "Menu.Dashboard", path: "/dashboard" },
  //         { text: "Menu.Messages", path: "/messages" },
  //         { text: "Menu.Tasks", path: "/tasks" }
  //     ]
  // },
  {
    id: 'work',
    icon: 'select-multiple',
    text: 'Menu.Work',
    subMenuItems: [
      { text: 'Menu.Tickets', path: '/tickets' },
      { text: 'Menu.MyTasks', path: '/tasks' },
      { text: 'Menu.AllTasks', path: '/all-tasks' }
    ]
  },
  {
    id: 'demographics',
    icon: 'building',
    text: 'Menu.Demographics',
    subMenuItems: [
      { text: 'Menu.Individuals', path: '/individuals', permission: ['CanViewIndividuals', 'CanSeeCbiIndividuals'] },
      { text: 'Menu.Banks', path: '/banks', permission: 'CanViewBanks' },
      { text: 'Menu.Companies', path: '/companies', permission: 'CanViewCompanies' },
      { text: 'Menu.BlackLists', path: '/blacklists', permission: 'CanViewBlackLists' },
      { text: 'Menu.Fines', path: '/fines', permission: 'CanViewFines' }
    ]
  },
  {
    id: 'data-crossings',
    icon: 'crosshair',
    text: 'Menu.DataCrossing',
    subMenuItems: [
      {
        text: 'Menu.DataCrossingsDuplicities',
        path: '/data-crossings-duplicates',
        permission: ['CanViewDataCrossingsDuplicates', 'CanManageDataCrossingsDuplicates']
      },
      {
        text: 'Menu.DataCrossingsDelinquents',
        path: '/data-crossings-delinquents',
        permission: ['CanViewDataCrossingsDelinquents', 'CanManageDataCrossingsDelinquents']
      }
    ]
  },
  {
    id: 'communication',
    icon: 'conversation',
    text: 'Menu.Communication',
    subMenuItems: [
      { text: 'Menu.Messages', path: '/messages', permission: ['CanViewMessages', 'CanManageMessages', 'CanCreateDrafts'] }
    ]
  },
  {
    id: 'blacklists-export',
    icon: 'grid',
    text: 'Menu.Exports',
    subMenuItems: [
      { text: 'Menu.BlacklistsExport', path: '/export-blacklists', permission: 'CanViewBlacklistsExport' }
    ]
  },
  {
    id: 'reports',
    icon: 'bxs-report',
    text: 'Menu.Reports',
    subMenuItems: [
      {
        text: 'Menu.ReportingGroups',
        path: '/reporting-groups',
        permission: ['CanViewReportGroups', 'CanManageReportGroups']
      },
      {
        text: 'Menu.ReportingYears',
        path: '/reporting-calendars',
        permission: ['CanViewReportingCalendars', 'CanManageReportingCalendars']
      },
      { text: 'Menu.SubmittedReports', path: '/report-submission-groups', permission: 'CanViewReportSubmissions' },
      { text: 'Menu.AllSubmittedReports', path: '/all-report-submissions', permission: 'CanViewReportSubmissions' },
      {
        text: 'Menu.ForecastSubmittedReports',
        path: '/forecast-report-submission-groups',
        permission: 'CanViewForecastSubmissions'
      },
      {
        text: 'Menu.ForecastAllSubmittedReports',
        path: '/forecast-all-report-submissions',
        permission: 'CanViewForecastSubmissions'
      },
      {
        text: 'Menu.InstitutionGroups',
        path: '/institution-groups',
        permission: ['CanViewInstitutionGroups', 'CanManageInstitutionGroups']
      }
    ]
  },
  {
    id: 'output-reports',
    icon: 'file',
    text: 'Menu.OutputReports',
    subMenuItems: [
      { text: 'Reporting.OutputReportGroups', path: '/output-report-groups', permission: 'CanViewOutputReports' },
      {
        text: 'Menu.Definitions',
        path: '/output-report-definitions',
        permission: 'CanManageOutputReportGroupDefinitions'
      },
      {
        text: 'Menu.OutputReportGenerator',
        path: '/output-report-generator',
        permission: 'CanManageOutputReportGenerator'
      },
      {
        text: 'Menu.InstitutionReportGroups',
        path: '/icbs-report-groups',
        permission: ['CanViewICBSReportGroups', 'CanManageICBSReportGroups']
      },
      { text: 'Menu.BlacklistReports', path: '/blacklist-reports', permission: 'CanViewBlacklistReports' },
      { text: 'Menu.Qlik', path: '/qlik', permission: 'CanAccessQlik' }
    ]
  },
  {
    id: 'rtgsreports',
    icon: 'bxs-report',
    text: 'Menu.RtgsReports',
    subMenuItems: [
      {
        text: 'Menu.RtgsReports',
        path: '/rtgsreports',
        permission: ['CanViewRtgsreports']
      }
    ]
  },
  {
    id: 'organization-structure',
    icon: 'world',
    text: 'Menu.OrganizationalStructure',
    subMenuItems: [
      {
        text: 'Menu.OrganizationalUnitsManagement',
        path: '/organizational-units',
        permission: ['CanViewOrganizationalUnitManagement', 'CanManageOrganizationalUnits']
      }
    ]
  },
  {
    id: 'logs',
    icon: 'laptop',
    text: 'Menu.Logs',
    permission: 'CanViewSystemLogs',
    subMenuItems: [
      { text: 'Menu.AuditLogs', path: '/audit-logs' },
      { id: 'logs_systemlogs', text: 'Menu.KibanaLogs', path: '/kibana/discover' },
      { id: 'logs_apm', text: 'Menu.Apm', path: '/kibana/apm' }
    ]
  },
  {
    id: 'documentation',
    icon: 'file',
    text: 'Menu.Documentation',
    subMenuItems: [
      { text: 'Menu.DocumentationViewer', path: '/documentation' }
    ]
  },
  {
    id: 'administration',
    icon: 'cog',
    text: 'Menu.Administration',
    subMenuItems: [
      { text: 'Menu.PasswordPolicy', path: '/password-policy', permission: 'CanManagePasswordPolicy' },
      {
        text: 'Menu.ReportTemplatesAdministration',
        path: '/administration-report-templates',
        permission: ['CanManageReportTemplates', 'CanViewReportTemplates']
      },
      {
        text: 'Menu.ReportCheckingRules',
        path: '/checking-rules',
        permission: ['CanViewCheckingRules', 'CanManageCheckingRules']
      },
      {
        text: 'Menu.WorkflowConfiguration',
        path: '/workflow-configuration',
        permission: 'CanManageWorkflowConfiguration'
      },
      {
        text: 'Menu.CodeListManagement',
        path: '/code-lists',
        permission: ['CanViewCodeListManagement', 'CanManageCodeLists']
      },
      { text: 'Menu.Translations', path: '/resources-administration', permission: 'CanManageTranslations' },
      { text: 'Menu.Documentation', path: '/administration/documentation', permission: 'CanManageDocumentation' },
      { text: 'Menu.UserManagement', path: '/users', permission: 'CanManageUsers' },
      { text: 'Menu.AnnouncementSettings', path: '/announcements', permission: 'CanManageAnnouncementSettings' },
      { text: 'Menu.HelpPages', path: '/administration/help-pages', permission: 'CanManageHelp' },
      { text: 'Menu.DataCrossing', path: '/administration/data-crossing', permission: 'CanManageDataCrossing' },
      { text: 'Menu.SystemRsaKeys', path: '/system-rsa-keys', permission: 'CanManageSystemRsaKeys' },
      {
        text: 'Menu.ReportConstants',
        path: '/report-constant-categories',
        permission: ['CanViewReportingConstants', 'CanManageReportingConstants']
      },
      {
        text: 'Menu.QlikDimensions',
        path: '/dimensions-qlik',
        permission: ['CanViewQlikDimensions', 'CanManageQlikDimensions']
      },
      {
        text: 'Menu.IcbsReportAdministration',
        path: '/icbs-report-administration',
        permission: 'CanManageICBSReportGroups'
      },
      { text: 'Menu.Settings', path: '/settings', permission: 'CanManageSettings' }
    ]
  },
  {
    id: 'testing',
    icon: 'bxs-flask',
    text: 'Menu.Testing',
    subMenuItems: [
      {
        text: 'Menu.TemporaryReportGroupSubmissions',
        path: '/report-group-submission-temporary',
        permission: 'CanViewTemporaryReportGroupSubmissions'
      },
      {
        text: 'Menu.InputReportBulkUpload',
        path: '/input-report-bulk-upload',
        permission: 'CanViewTemporaryReportGroupSubmissions'
      },
      { text: 'Menu.TemporaryFileAttachments', path: '/files-temporary', permission: 'CanViewTemporaryFileAttachments' },
      { text: 'Menu.ExcelTest', path: '/excel-export', permission: 'CanViewExcelTest' },
      { text: 'Menu.TemporaryWorkflowRunner', path: '/temporary-workflow-runner', permission: 'CanViewWorkflowRunner' }
    ]
  }
]

export default APPLICATION_MENU



// WEBPACK FOOTER //
// ./src/internal-app/menu-content.js